/**
 * Session Timeout Warning Script for Shopify
 * Satisfies WCAG 2.2.1 (Timing Adjustable)
 */

(function() {
  // CONFIGURATION
  const SESSION_DURATION = 20 * 60 * 1000; // 20 minutes in milliseconds
  const WARNING_THRESHOLD = 60 * 1000;    // Show warning 60 seconds before expiry
  const EXTEND_THRESHOLD = 20 * 1000;     // Minimum warning time required by WCAG
  
  let timeoutTimer;
  let warningTimer;
  let lastActivity = Date.now();

  // Create Modal Elements
  function createModal() {
    const modal = document.createElement('div');
    modal.id = 'session-timeout-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-labelledby', 'timeout-title');
    modal.setAttribute('aria-describedby', 'timeout-desc');
    modal.setAttribute('aria-modal', 'true');
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.8);
      display: none;
      justify-content: center;
      align-items: center;
      z-index: 999999;
      font-family: sans-serif;
    `;

    const content = document.createElement('div');
    content.style.cssText = `
      background: #fff;
      padding: 2rem;
      border-radius: 8px;
      max-width: 400px;
      width: 90%;
      text-align: center;
      box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    `;

    content.innerHTML = `
      <h2 id="timeout-title" style="margin-top: 0; color: #333;">Session Expiring Soon</h2>
      <p id="timeout-desc" style="color: #666; margin-bottom: 1.5rem;">
        Your session will expire in <span id="timeout-countdown">60</span> seconds due to inactivity. 
        Would you like to stay logged in?
      </p>
      <div style="display: flex; gap: 10px; justify-content: center;">
        <button id="extend-session-btn" style="
          background: #000;
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
        ">Stay Logged In</button>
        <button id="logout-now-btn" style="
          background: #eee;
          color: #333;
          border: 1px solid #ccc;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
        ">Logout Now</button>
      </div>
    `;

    modal.appendChild(content);
    document.body.appendChild(modal);

    document.getElementById('extend-session-btn').addEventListener('click', extendSession);
    document.getElementById('logout-now-btn').addEventListener('click', expireSession);
  }

  function resetTimers() {
    clearTimeout(timeoutTimer);
    clearTimeout(warningTimer);
    hideModal();

    // Set warning timer
    warningTimer = setTimeout(showWarning, SESSION_DURATION - WARNING_THRESHOLD);
    
    // Set final timeout timer
    timeoutTimer = setTimeout(expireSession, SESSION_DURATION);
  }

  function showWarning() {
    const modal = document.getElementById('session-timeout-modal');
    if (!modal) return;

    modal.style.display = 'flex';
    document.getElementById('extend-session-btn').focus();

    let timeLeft = WARNING_THRESHOLD / 1000;
    const countdownEl = document.getElementById('timeout-countdown');
    
    const countdownInterval = setInterval(() => {
      timeLeft--;
      if (countdownEl) countdownEl.textContent = timeLeft;
      if (timeLeft <= 0 || modal.style.display === 'none') {
        clearInterval(countdownInterval);
      }
    }, 1000);
  }

  function hideModal() {
    const modal = document.getElementById('session-timeout-modal');
    if (modal) modal.style.display = 'none';
  }

  function extendSession() {
    // In Shopify, "extending" usually just means refreshing the page or making a small AJAX call
    // to keep the cookie alive. For a general warning, we just reset our local timer.
    fetch('/cart.js').then(() => {
      resetTimers();
      console.log('Session extended');
    });
  }

  function expireSession() {
    // Save any form data if needed
    saveFormData();
    
    // Redirect to logout or home
    window.location.href = '/account/logout';
  }

  function saveFormData() {
    const forms = document.querySelectorAll('form');
    forms.forEach((form, index) => {
      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());
      localStorage.setItem(`saved_form_${index}_${window.location.pathname}`, JSON.stringify(data));
    });
  }

  function handleActivity() {
    const now = Date.now();
    // Throttle activity checks to every 30 seconds to save performance
    if (now - lastActivity > 30000) {
      lastActivity = now;
      resetTimers();
    }
  }

  // Initialize
  function init() {
    createModal();
    resetTimers();

    // Listen for user activity
    ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach(event => {
      document.addEventListener(event, handleActivity, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();